import React from 'react';

export default function OnboardingTip({ onDismiss }) {
  return (
    <div className="onboarding-tip" role="note">
      <div className="onboarding-tip__content">
        <p className="onboarding-tip__title">เริ่มต้นใช้งาน Hotto</p>
        <p className="onboarding-tip__text">
          พิมพ์ความฝัน เลข หรือคำทำนาย แล้วกดค้นหา — ระบบจะจำการค้นหาล่าสุดให้คุณอัตโนมัติ
        </p>
      </div>
      <button type="button" className="onboarding-tip__dismiss" onClick={onDismiss} aria-label="ปิดคำแนะนำ">
        เข้าใจแล้ว
      </button>
    </div>
  );
}
